import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { BaseModalDirective } from '../base-modal';

@Component({
    selector: 'nh-submission-types',
    templateUrl: './submission-types.component.html',
    styleUrls: ['./submission-types.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false
})
export class SubmissionTypesComponent extends BaseModalDirective implements OnInit{

  statuses = [
    { title: "STATUS_MODAL_TEXT", description: "STATUS_MODAL_DATA" },
    { title: "STATUS_MODAL_TEXT_01", description: "STATUS_MODAL_DATA_01" },
    { title: "STATUS_MODAL_TEXT_02", description: "STATUS_MODAL_DATA_02" },
    { title: "STATUS_MODAL_TEXT_03", description: "STATUS_MODAL_DATA_03" }
  ]

  ngOnInit() {
    
  }
}
